class d {
  constructor(r) {
    this.dsl = r, this.validateDSL();
  }
  /**
   * 验证 DSL 定义
   */
  validateDSL() {
    const { rules: r } = this.dsl;
    if (!r.some((o) => o.type === "start"))
      throw new i('At least one "start" rule is required', "MISSING_START_RULE");
    if (!r.some((o) => o.type === "end"))
      throw new i('At least one "end" rule is required', "MISSING_END_RULE");
  }
  /**
   * 生成 Slides
   */
  generate(r) {
    if (r.sourceType !== this.dsl.sourceType)
      throw new i(
        `Context source type "${r.sourceType}" does not match DSL source type "${this.dsl.sourceType}"`,
        "SOURCE_TYPE_MISMATCH"
      );
    const n = [], { rules: t } = this.dsl, o = t.filter((e) => e.type === "start"), l = t.filter((e) => e.type === "content"), c = t.filter((e) => e.type === "end");
    for (const e of o)
      try {
        const s = e.generate(r);
        n.push(...this.enrichSlides(s, e.name));
      } catch (s) {
        throw new i(
          `Error in start rule "${e.name}": ${s.message}`,
          "RULE_GENERATION_ERROR",
          s
        );
      }
    for (const e of l)
      try {
        const s = e.generate(r);
        n.push(...this.enrichSlides(s, e.name));
      } catch (s) {
        throw new i(
          `Error in content rule "${e.name}": ${s.message}`,
          "RULE_GENERATION_ERROR",
          s
        );
      }
    for (const e of c)
      try {
        const s = e.generate(r);
        n.push(...this.enrichSlides(s, e.name));
      } catch (s) {
        throw new i(
          `Error in end rule "${e.name}": ${s.message}`,
          "RULE_GENERATION_ERROR",
          s
        );
      }
    return n;
  }
  /**
   * 丰富 Slides（添加默认值、生成 ID 等）
   */
  enrichSlides(r, n) {
    return r.map((t, o) => ({
      ...t,
      id: t.id || `${n}-${o}`,
      behavior: {
        ...this.dsl.config?.defaultTransition && {
          transition: this.dsl.config.defaultTransition
        },
        ...this.dsl.config?.defaultBackground && {
          background: this.dsl.config.defaultBackground
        },
        ...t.behavior
      }
    }));
  }
}
class i extends Error {
  constructor(r, n, t) {
    super(r), this.code = n, this.cause = t, this.name = "SlideEngineError";
  }
}
export {
  d as SlideEngine,
  i as SlideEngineError
};
//# sourceMappingURL=index.mjs.map
